import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IUsersResponse {
  success: boolean;
  message: string;
  data: IUsersData[];
}

export interface IUsersData {
  userid: number;
  username: string;
  email: string;
  creationdate: Date | string;
  idarea: number;
  areaname: string;
  role: string;
  picture: null | string;
  firstname: null | string;
  secondname: null | string;
  firstlastname: null | string;
  secondlastname: null | string;
  address: null | string;
  telephone: null | string;
  birthday: null | string;
  idcompany: null | number | string;
  seniority: null | string;
  state: string;
}

interface UsersState {
  users: IUsersData[];
  message: string;
  success: boolean;
}

const initialState: UsersState = {
  users: [],
  message: "",
  success: false,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    loadUsers(state, action: PayloadAction<IUsersResponse>) {
      state.users = action.payload.data;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    diMissUsers(state) {
      state.users = [];
      state.message = '';
      state.success = false;
    },
  },
});

export const { loadUsers, diMissUsers } = usersSlice.actions;

export default usersSlice.reducer;
